import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

export const ColumnIds = {
  NAME: 'name',
  AMOUNT: 'amount',
};

export const columnsDefs = [
  {
    id: ColumnIds.NAME,
    label: 'Name',
  },
  {
    id: ColumnIds.AMOUNT,
    label: 'Total Amount',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
  },
];

export const DEFAULT_TABLE_TITLE = 'Other Credits';
